import { IBaseProperties } from '@bvi/api-interfaces/entity/base';
import { ICompanyWithUsers } from '@bvi/api-interfaces/entity/company';
import { ISubscription } from '@bvi/api-interfaces/entity/subscription';

export enum ClientStatus {
  Unconfirmed = 'unconfirmed',
  Active = 'active',
  Archived = 'archived',
}

export enum AccountStatus {
  DoNotActivate = 'do_not_activate',
  ReadyToActivate = 'ready_to_activate',
  Active = 'active',
}

export enum PaymentMethod {
  Ach = 'ach',
  Wire = 'wire',
  CreditCard = 'credit_card',
  Check = 'check',
  Other = 'other',
}

export interface IClientBase extends IBaseProperties {
  status: ClientStatus;
  accountStatus: AccountStatus;
  pricingNarrative?: string | null;
  accountManagerName?: string | null;
  accountManagerEmail?: string | null;
  supportLiaisonName?: string | null;
  supportLiaisonEmail?: string | null;
  paymentMethod?: PaymentMethod | null;
}

export interface IClientWithSubscription extends IClientBase {
  subscription: ISubscription;
}

export interface IClient extends IClientWithSubscription {
  company: ICompanyWithUsers;
}
